import angular from 'angular';
import '@updater-components/typeahead';
import { IdentifiersModalComponent } from './identifiers-modal';
import { UFaIconComponent } from '@updater/angular-common';
import { UpdateAccountsSearchComponent } from './search.component';
import { UpdateAccountsSearchConfig } from './search.config';
import { LoadingDotsModule } from '../../../common/directives';

export const UpdateAccountsSearchModule = angular
  .module('app.steps.update-accounts.search', [
    LoadingDotsModule.name,
    UFaIconComponent.name,
  ])
  .config(UpdateAccountsSearchConfig)
  .component('updUpdateAccountsSearch', UpdateAccountsSearchComponent)
  .component('updIdentifiersModal', IdentifiersModalComponent);
